import { render, staticRenderFns } from "./DeleteModalDialog.vue?vue&type=template&id=1a8cfa36&"
import script from "./DeleteModalDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteModalDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports